export default __webpack_public_path__ + "static/media/agency.2bba69ce.png";